// extracted by mini-css-extract-plugin
module.exports = {"card":"card_card__R8e1Q","headingOverride":"card_headingOverride__RVhcI"};